import React from 'react';
import { Full } from '../../components/Indicator/index';
import loadable from '../../utils/loadable';

export default loadable(() => import('./index'), {
  fallback: <Full />,
});
